import {
  FormProviderContext,
  FormProviderContextProps,
} from '@/utils/providers/formProviderContext/FormContext';
import { ReactElement, useMemo } from 'react';
import { FieldValues, FormProvider as ReactFormProvider } from 'react-hook-form';

export const FormProvider = <
  TFieldValues extends FieldValues,
  TContext = unknown,
  TTransformedValues extends FieldValues | undefined = undefined,
>(
  props: FormProviderContextProps<TFieldValues, TContext, TTransformedValues>,
): ReactElement<FormProviderContextProps<TFieldValues, TContext, TTransformedValues>> => {
  const { validation, ...rest } = props;
  const providerValue = useMemo(() => ({ validation }), [validation]);

  return (
    <ReactFormProvider {...rest}>
      <FormProviderContext.Provider value={providerValue}>
        {props.children}
      </FormProviderContext.Provider>
    </ReactFormProvider>
  );
};
